import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from '../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view02ImageOptions } from './views/exterior_view02'

class X49MK2BowSprit extends Component {
    constructor(props) {
        super(props);
		this.handleBowSpritChange = this.handleBowSpritChange.bind(this);
    }


	handleBowSpritChange(event) {
		let configuration = this.props.configuration;
		let checked = event.target.checked;
		configuration.BowSpritRailing = checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };
		configuration.BowSpritLadder = checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

    render() {
		let imageOptions = exterior_view02ImageOptions;

		let image = <ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration} options={imageOptions} />;
        
        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>
                    <h1><Trans defaults='Bowsprit' /></h1>

                    <p><Trans defaults='X49 Bowsprit Text' /></p>

					<Toggle
						checked={this.props.configuration.BowSpritRailing.value === 2}
						onChange={this.handleBowSpritChange}>
						<Trans defaults='Bowsprit railing and bowsprit ladder' />
					</Toggle>

                   
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2BowSprit);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-BowSprit.js